import { Form, InputNumber, Popover } from 'antd'
import useFormInstance from 'antd/es/form/hooks/useFormInstance'
import { FC, useContext, useMemo, useState } from 'react'
import type CalculationPosition from '../../../../../../types/api/calculation-position'
import { EditableCellCtx } from '../../../../../../components/editable-cell/editable-cell'
import { getMaterialTypes } from '../../../../../../helpers/get-material-types'

interface CorrectMaterialCostProps {
    record?: CalculationPosition
}

const CorrectMaterialCost: FC<CorrectMaterialCostProps> = ({ record }) => {
    const ctx = useContext(EditableCellCtx)
    const form = useFormInstance()
    const fieldName = 'correctMaterialCost'
    const [open, setOpen] = useState(true)
    const materialTypes = useMemo(() => (record ? getMaterialTypes(record) : []), [record])

    const getDocIdFromEntry = (entry?: any) => {
        return entry?.material_type?.documentId ?? entry?.material_type?.connect?.[0]
    }

    // Приводим значение поля к ожидаемому payload-формату Strapi:
    // - выкидываем пустые цены
    // - схлопываем дубликаты по материалу
    // - материал_type приводим к виду { connect: [docId] }
    const normalizeCorrectMaterialCost = (list: any[]) => {
        const byDocId = new Map<string, any>()

        for (const entry of list ?? []) {
            const docId = getDocIdFromEntry(entry)
            if (!docId) continue

            const cost = entry?.cost
            if (cost == null || Number.isNaN(cost)) continue

            byDocId.set(docId, {
                ...entry,
                material_type: { connect: [docId] },
                cost,
            })
        }

        return [...byDocId.values()]
    }

    const onOpenChange = async (nextOpen: boolean) => {
        if (nextOpen) {
            setOpen(true)
            return
        } else {
            try {
                await form.validateFields()
                const list = (form.getFieldValue(fieldName) ?? []) as any[]
                form.setFieldValue(fieldName, normalizeCorrectMaterialCost(list))
                ctx.onBlur()
            } catch {
                setOpen(true)
            }
        }
    }

    return (
        <Popover
            open={open}
            onOpenChange={onOpenChange}
            trigger={'click'}
            placement={'bottomLeft'}
            content={
                <div
                    style={{ minWidth: 500 }}
                    onClick={e => e.stopPropagation()}
                    onMouseDown={e => e.stopPropagation()}
                >
                    <Form.List name={fieldName}>
                        {fields => (
                            <>
                                {fields.map(field => {
                                    const getDocIdFromForm = () =>
                                        form.getFieldValue([
                                            fieldName,
                                            field.name,
                                            'material_type',
                                            'connect',
                                            0,
                                        ])

                                    const material = materialTypes?.find(
                                        mt => mt.documentId === getDocIdFromForm()
                                    )

                                    return (
                                        <Form.Item
                                            name={[field.name, 'cost']}
                                            label={material?.name}
                                            labelCol={{ span: 20 }}
                                            wrapperCol={{ span: 4 }}
                                            key={field.key}
                                        >
                                            <InputNumber
                                                style={{ width: 80 }}
                                                controls={false}
                                                min={0}
                                                placeholder={'Цена'}
                                            />
                                        </Form.Item>
                                    )
                                })}
                            </>
                        )}
                    </Form.List>
                </div>
            }
        >
            <span> </span>
        </Popover>
    )
}

export default CorrectMaterialCost
